import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Typography, Collapse } from 'seagull';
import { ChevronDown, ChevronUp } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import AgreementServiceInstance from './AgreementServiceInstance';
import styles from './StatementOfWork.module.scss';
import { splitServices } from './StatementOfWork.utils';
const toggleIconSize = 18;
export default function StatementOfWork(props) {
    const { services, isVendor, qboClasses, serviceDetailsProps } = props;
    const { t: viewTexts } = useLocaleKeys('pages.agreementMinisite.agreementView');
    const [activeServices, inactiveServices] = useMemo(()=>splitServices(services, isVendor), [
        isVendor,
        services
    ]);
    const [stoppedOrCompletedServicesShown, setStoppedOrCompletedServicesShown] = useState(activeServices.length === 0);
    const renderService = (addToIdx)=>(service, idx)=>/*#__PURE__*/ _jsx(AgreementServiceInstance, {
                qboClasses: qboClasses,
                serviceDetailsProps: serviceDetailsProps,
                service: service,
                idx: idx + addToIdx
            }, service.id);
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.root,
        children: [
            activeServices.map(renderService(0)),
            inactiveServices.length > 0 && /*#__PURE__*/ _jsxs("div", {
                className: styles.stoppedOrCompletedServicesContainer,
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        className: styles.header,
                        "data-testid": "toggle-stopped-completed-services",
                        onClick: ()=>setStoppedOrCompletedServicesShown(!stoppedOrCompletedServicesShown),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: viewTexts.stoppedAndCompletedServices()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                skin: "secondary",
                                children: stoppedOrCompletedServicesShown ? /*#__PURE__*/ _jsx(ChevronUp, {
                                    size: toggleIconSize
                                }) : /*#__PURE__*/ _jsx(ChevronDown, {
                                    size: toggleIconSize
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Collapse, {
                        in: stoppedOrCompletedServicesShown,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.collapseContainer,
                            children: inactiveServices.map(renderService(activeServices.length))
                        })
                    })
                ]
            })
        ]
    });
}
